import { ApplicationActionType } from '../../../ApplicationConstants';
import { performCellDoubleClick } from './onCellDblClick';

export const onCellDblClickReview = (e) => {
    performCellDoubleClick(e, ApplicationActionType.Review);
};
